 import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// استيراد ملفات الترجمة
import en from './locales/en';
import ar from './locales/ar';

// قائمة اللغات
const resources = {
  en: { translation: en },
  ar: { translation: ar },
};

i18n
  .use(LanguageDetector) // كشف اللغة التلقائي
  .use(initReactI18next) // دمج مع React
  .init({
    resources, // الترجمات مضمنة هنا
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // React يحمي من XSS
      formatSeparator: ',',
    },

    // كشف اللغة
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage'], // حفظ اللغة المختارة
    },
  });

export default i18n;